<script>
export default {
  name: "TaxReturnTableHeader"
}
</script>

<template>
  <tr>
    <th>
      <translate>Beschrijving</translate>
    </th>

    <th>
      <translate>Waarde</translate>
    </th>

    <th>
      <translate>Verschil</translate>
    </th>
  </tr>
</template>

<style scoped lang="scss">

</style>